import { useSelector } from 'react-redux';
import { metricSentenceCase, formatNumberGivenValueType } from 'modules/productAnalytics/utils';
import { METRIC_VALUES_TO_LABELS } from 'constants/metricValuesToLabels';
import { Skeleton } from 'ui/skeleton';
import { StyledDivider } from 'modules/productAnalytics/Styled';
import { MetricBreakdownCard } from './MetricBreakdownCard';
import { SendSkipBreakdown } from './SendSkipBreakdown';
import {
  MetricBreakdownContainer,
  MetricBreakdownHeaderContainer,
  MetricBreakdownHeaderTitle,
  MetricBreakdownHeaderValue,
  SkeletonWrapper,
  MetricBreakdownRowWithTwoUnequalColumns,
  StyledListContainer,
} from './Styled';
import { selectAnalyticsMetricsValueTypes } from '../selectors';
import { MetricDefinitionWrapper } from './MetricDefinitionWrapper';

export const SendSkipCard = ({ medium, headerChart, results, isLoading, sendSkipBuckets }) => {
  const valueTypes = useSelector(selectAnalyticsMetricsValueTypes);
  const totalSendSkipsKey = METRIC_VALUES_TO_LABELS[`Total${medium}SendSkip`];
  const { UNEXPECTED, EXPECTED } = sendSkipBuckets || {};
  return (
    <MetricBreakdownCard title="Send skips">
      {isLoading ? (
        <SkeletonWrapper height={256} padding={24}>
          <Skeleton />
        </SkeletonWrapper>
      ) : (
        <MetricBreakdownContainer>
          <MetricBreakdownHeaderContainer>
            <MetricBreakdownRowWithTwoUnequalColumns>
              <div>
                <MetricBreakdownHeaderTitle data-test="metric-title-send-skip">
                  <MetricDefinitionWrapper metricName={totalSendSkipsKey}>
                    {metricSentenceCase(totalSendSkipsKey)}
                  </MetricDefinitionWrapper>
                </MetricBreakdownHeaderTitle>
                <MetricBreakdownHeaderValue data-test="metric-value-send-skip">
                  {formatNumberGivenValueType(
                    valueTypes[totalSendSkipsKey],
                    results[totalSendSkipsKey]?.value,
                  ) || 'N/A'}
                </MetricBreakdownHeaderValue>
              </div>
              {headerChart}
            </MetricBreakdownRowWithTwoUnequalColumns>
          </MetricBreakdownHeaderContainer>

          <StyledDivider />
          <StyledListContainer>
            {UNEXPECTED && <SendSkipBreakdown bucket={UNEXPECTED} reasonPrefix={'unexpected'} />}
            {EXPECTED && <SendSkipBreakdown bucket={EXPECTED} reasonPrefix={'expected'} />}
          </StyledListContainer>
        </MetricBreakdownContainer>
      )}
    </MetricBreakdownCard>
  );
};
